<template>
  <div class="moduleStyle minHeight" style="padding: 20px">
    <el-form size="small" :inline="true">
      <el-form-item label="选择用户">
        <el-select
          v-model="pickUserID"
          filterable
          remote
          reserve-keyword
          placeholder="请输入用户名/手机号"
          :remote-method="remoteMethod"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item>
        <el-button type="primary" plain @click="handleSubmit">提交</el-button>
      </el-form-item> -->
    </el-form>

    <!-- <el-select v-model="pickUserName" placeholder="">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select> -->

    <!-- <el-input
      v-model="pickUserName"
      placeholder="请输入要设置权限的用户名称,这里是测试，所以直接输入UserID"
    ></el-input> -->

    <div class="permission_table">
      <el-table :data="storeList" border>
        <el-table-column
          v-for="store in storeList[0]"
          :key="store.shop_id"
          :label="store.name"
          prop="store.shop_id"
        >
          <template v-slot="scope">
            <el-tree
              :data="getProcessedPermissionTree(store.shop_id)"
              show-checkbox
              node-key="nodeKey"
              ref="tree"
              highlight-current
              :props="defaultProps"
              @check-change="(data, checked) => handleNodeClick(data, checked, store)"
              :default-checked-keys="getDefaultCheckedKeys(store)"
            >
            </el-tree>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-form size="small" :inline="true">
      <el-form-item>
          <el-button type="primary" plain @click="handleSubmit">确认</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import {
  userGetlist,
  permissionGetlist,
  getUserShoplist,
  userPermissionGetlist,
  userPermissionSetlist,
} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
export default {
  name: "rolePermissions",
  data() {
    return {
      compId: null,
      permissionTree: [],
      defaultProps: {
        children: "sub_list",
        label: "name",
      },

      pickUserName: "", // 选择的要设置权限的用户，用户名用于显示（不是自己）
      pickUserID: null, // 选择的要设置权限的用户，用户ID用于业务逻辑（不是自己）

      storeList: [], // 被设置权限的用户，他所属的店面

      debounceTimer: null, // 防抖定时器
      userPermissionOLD: [], // 被设置权限的用户，他已经拥有的权限
      userPermissionOLDMap: {}, //
      userPermissionNew: [], //
      options: [],
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;

    // 进来先拿权限树，权限树是固定不变的
    this.getTree();
  },
  watch: {
    // 观察user_id的变化
    pickUserID(newUserId, oldUserId) {
      console.log(
        "%c [ newUserId, oldUserId ]-106",
        "font-size:13px; background:pink; color:#bf2c9f;",
        newUserId,
        oldUserId
      );
      if (newUserId) {
        // 防抖，清除之前的定时器
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }
        // 设置一个新的定时器
        this.debounceTimer = setTimeout(() => {
          this.fetchData(newUserId);
        }, 300); // 300ms 防抖时间
      }
    },
  },

  methods: {
    remoteMethod(query) {
      if (query !== "") {
        setTimeout(() => {
          userGetlist({
            status: 1,
            comp_id: this.compId,
            keywords: query,
          }).then((res) => {
            if (res.code == 1) {
              this.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }, 200);
      } else {
        this.options = [];
      }
    },

    processOldPermission(list) {
        // 已有权限先复制一份到新权限表，再增删改
        this.userPermissionNew = list.map(item => {
          return { ...item };
        });

        // 根据已有权限表做默认选中操作
        // 创建一个 Map 对象来存储结果
        let shopPermissionsMap = new Map();
        // 遍历数据，并将 permission_id 添加到对应的 shop_id 键下
        list.forEach(item => {
          // 如果 Map 中已有该 shop_id，就将 permission_id 添加到它的数组中
          if (shopPermissionsMap.has(item.shop_id)) {
            let permissions = shopPermissionsMap.get(item.shop_id);
            permissions.push(item.permission_id);
            shopPermissionsMap.set(item.shop_id, permissions);
          } else {
            // 如果没有，就创建一个新的数组，只包含当前的 permission_id
            shopPermissionsMap.set(item.shop_id, [item.permission_id]);
          }
        });
        this.userPermissionOLDMap = shopPermissionsMap
    },

    getProcessedPermissionTree(shopId) {
      let processNode = (node, shopId) => {
        const newNode = { ...node };
        newNode.nodeKey = `${shopId}-${node.id}`;
        // 递归处理每个子节点
        if (newNode.sub_list) {
          newNode.sub_list = newNode.sub_list.map(childNode => processNode(childNode, shopId));
        }
        return newNode;
      };
      // 处理顶级节点
      return this.permissionTree.map(node => processNode(node, shopId));
    },

    // 默认选中
    getDefaultCheckedKeys(row) {
      let shopId = row.shop_id      
      let permission_ids = this.userPermissionOLDMap.has(shopId) ? this.userPermissionOLDMap.get(shopId) : [];
      const newList = permission_ids.map(item => {
        return `${shopId}-${item}`
      });   
      return newList
    },

    handleSubmit() {
      let submitData = []
      this.$refs.tree.forEach(item=>{
        console.log(item)
        let leafNodes = item.getCheckedNodes(true)
        leafNodes.forEach(it=>{
            let parts = it.nodeKey.split("-");
            submitData.push({
              'shop_id': parseInt(parts[0]), 
              'permission_id': parseInt(parts[1]) 
            })
        })
      })
      this.setUserPermissionList({
        user_id: this.pickUserID,
        comp_id: this.compId,
        list: submitData
      }).then(()=>{
        this.$message.success("操作成功");
      })
    },
    handleNodeClick(data, checked, store) {
      let permission_id = data.id;
      let shop_id = store.shop_id;
      if (checked) {
        // 检查数组中是否已经存在相同的权限对象
        const existingPermission = this.userPermissionNew.find(
          (p) => p.permission_id === permission_id && p.shop_id === shop_id
        );

        // 如果找不到匹配的权限对象，则添加新的权限对象
        if (!existingPermission) {
          this.userPermissionNew.push({
            permission_id: permission_id,
            shop_id: shop_id,
          });
        } else {
          // 查找匹配项的索引
          const index = this.userPermissionNew.findIndex(
            (p) => p.permission_id === permission_id && p.shop_id === shop_id
          );

          // 如果找到了匹配的权限对象，从数组中删除它
          if (index !== -1) {
            this.userPermissionNew.splice(index, 1);
          }
        }
      }
    },
    fetchData(pickUserId) {
      if (pickUserId) {
        Promise.all([
          this.getUserPermissionList(pickUserId),
          this.getStoreList(pickUserId),
        ])
          .then((res) => {
            this.userPermission = res[0];
            this.storeList = [res[1]];

            this.userPermissionOLD = res[0]
            this.processOldPermission(res[0])
          })
          .catch((error) => {
            console.error("An error occurred:", error);
          });
      }
    },
    getTree() {
      return permissionGetlist().then((res) => {
        if (res.code == 1) {
          this.permissionTree = res.data;
          console.log(
            "%c [  ]-33",
            "font-size:13px; background:pink; color:#bf2c9f;",
            res
          );
        }
      });
    },
    getStoreList(pickUserId) {
      // 是找用设计权限的用户拥有的店铺，所以是 pickUserId, 没有的话需要先输入关键字，搜一遍用户并选中
      // let data = JSON.parse(getRoles());
      return getUserShoplist({ comp_id: 100, user_id: pickUserId }).then(
        (res) => {
          if (res.code == 1) {
            return res.data;
          }
        }
      );
    },
    getUserPermissionList(pickUserId) {
      // 同上，是找用设计权限的用户拥有的店铺，所以是 pickUserId, 没有的话需要先输入关键字，搜一遍用户并选中
      // let data = JSON.parse(getRoles());
      return userPermissionGetlist({ comp_id: 100, user_id: pickUserId }).then(
        (res) => {
          if (res.code == 1) {
            return res.data;
          }
        }
      );
    },
    setUserPermissionList(json) {
      return userPermissionSetlist(json).then((res) => {
        if (res.code == 1) {
          return res.data;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/rolePermissions/index.vue